import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { getValidationMessages, emailRegExp } from '@/shared/constants';
import InputField, { InputFieldProps } from './InputField';

type EmailFieldProps = Omit<InputFieldProps, 'name' | 'placeholder'> &
  Partial<Pick<InputFieldProps, 'name' | 'placeholder'>> & {
    isRequired?: boolean;
  };

const EmailField: FC<EmailFieldProps> = ({
  label,
  name = 'email',
  placeholder,
  isRequired,
  validationParameters,
  ...restProps
}) => {
  const { t } = useTranslation();
  const messages = getValidationMessages(t);
  const defaultLabel = label || t('common.form.email');
  const defaultPlaceholder = placeholder || t('common.form.emailPlaceholder');

  return (
    <InputField
      label={defaultLabel}
      name={name}
      placeholder={defaultPlaceholder}
      validationParameters={{
        required: isRequired ? messages.requiredField(defaultLabel) : undefined,
        pattern: {
          value: emailRegExp,
          message: messages.wrongEmail(),
        },
        ...validationParameters,
      }}
      {...restProps}
    />
  );
};

export default EmailField;
